// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__3wQTv","colCheckbox":"styles_colCheckbox__3qZyI"};